<template>
    <div>




        <EmailSignIn class="my-4 my-md-7" />
        <OrSeparator class="my-7"/>
        <SigninWithGoogleButton class="mt-4"/>
        <SigninWithFacebookButton class="mt-4"/>




    </div>
</template>



<script setup>

import EmailSignIn from './EmailSignIn.vue'
import OrSeparator from '@/components/Auth/AuthDialog/Elements/OrSeparator.vue';
import SigninWithGoogleButton from '@/components/Auth/Common/SigninWithGoogleButton.vue'
import SigninWithFacebookButton from '@/components/Auth/Common/SigninWithFacebookButton.vue'


</script>